// extracted by mini-css-extract-plugin
module.exports = {"container":"TrustPage_container__1_vAT","item":"TrustPage_item__1OkBP"};